<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <el-form-item label="手机号: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.phone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="openid: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" v-waves style="margin: 0 10px 10 0">搜索</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="disable" slot-scope="{ row }">
          <el-tag v-if="row.disable === 1" type="danger" effect="dark" size="mini">异常用户</el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">正常用户</el-tag>
        </template>
        <template slot="phone" slot-scope="scope">
          {{
          scope.row.phone ? scope.row.phone : "用户暂未绑定手机号"
          }}
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              @click="handleDisable(row)"
              primary
            >{{ row.disable === 1 ? "启用" : "禁用" }}</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
            <el-button size="mini" type="text" @click="handleData(row)">数据统计</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 数据统计弹窗 -->
    <el-dialog
      title="用户数据统计"
      :visible.sync="showStatDialog"
      width="60%"
      @closed="handleDialogClosed"
    >
      <div class="user-stat-container">
        <div class="user-info">
          <h3>用户信息</h3>
          <p>
            <strong>用户昵称:</strong>
            {{ currentUser.username|| '暂未完善' }}
          </p>
          <p>
            <strong>手机号:</strong>
            {{ currentUser.phone || '暂未绑定' }}
          </p>
          <p>
            <strong>OpenID:</strong>
            {{ currentUser.openid }}
          </p>
        </div>

        <div class="stat-cards">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="stat-content">
              <h4>用户拉新数</h4>
              <span class="stat-number">{{ userStats.newUserCount }}</span>
              <p class="stat-desc">该用户邀请的新用户数量</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-refresh"></i>
            </div>
            <div class="stat-content">
              <h4>复购数</h4>
              <span class="stat-number">{{ userStats.repurchaseCount }}</span>
              <p class="stat-desc">用户重复购买次数</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-shopping-cart-2"></i>
            </div>
            <div class="stat-content">
              <h4>消费总次数</h4>
              <span class="stat-number">{{ userStats.totalConsumptionCount }}</span>
              <p class="stat-desc">用户累计消费次数</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-coin"></i>
            </div>
            <div class="stat-content">
              <h4>消费总金额</h4>
              <span class="stat-number">¥{{ userStats.totalAmount }}</span>
              <p class="stat-desc">用户累计消费金额</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-date"></i>
            </div>
            <div class="stat-content">
              <h4>最近消费时间</h4>
              <span class="stat-text">{{ userStats.lastConsumptionTime }}</span>
              <p class="stat-desc">用户最后一次消费时间</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="stat-content">
              <h4>会员等级</h4>
              <span class="stat-text">{{ userStats.memberLevel }}</span>
              <p class="stat-desc">当前会员等级</p>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showStatDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import {
  selectUser,
  deleteUser,
  disableUser,
  statistics
} from "@/services/mall/user";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],
      /* 数据统计弹窗 */
      showStatDialog: false,
      currentUser: {},
      userStats: {
        newUserCount: 0,
        repurchaseCount: 0,
        totalConsumptionCount: 0,
        totalAmount: 0,
        lastConsumptionTime: "",
        memberLevel: ""
      }
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader
  },
  watch: {},
  methods: {
    async getListData() {
      this.loading = true;
      const { data, code, count } = await selectUser(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 禁用 */
    handleDisable(row) {
      this.$confirm(
        `确定${row.disable === 1 ? "启用" : "禁用"}用户"${
          row.phone ? row.phone : row.openid
        }"吗?`,
        "禁用",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(res => {
        disableUser({ id: row.id, disable: row.disable === 1 ? 0 : 1 }).then(
          res => {
            if (res.code === 200) {
              this.getListData();
              this.$message({
                type: "success",
                message: "操作成功!"
              });
            }
          }
        );
      });
    },
    /* 删除 */
    handleDelete(row) {
      this.$confirm(
        `确定删除用户"${row.phone ? row.phone : row.openid}"吗?`,
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(res => {
        deleteUser({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    },
    /* 数据统计 */
    handleData(row) {
      this.currentUser = row;
      this.generateMockData();
      this.showStatDialog = true;
    },
    /* 生成模拟数据 */
    async generateMockData() {
      let res = await statistics({
        openid: this.currentUser.openid,
        phone: this.currentUser.phone
      });
      if (res.code === 200) {
        // 生成随机的假数据
        this.userStats = {
          newUserCount: res.shareCount, // 分享数
          repurchaseCount: res?.rebuy || 0, // 1-20次
          totalConsumptionCount: res?.orderCount?.orderCount || 0, // 消费次数
          totalAmount: res?.orderCount?.totalPrice || 0, // 消费总金额
          lastConsumptionTime: res?.orderCount?.lastOrderTime || "暂无",
          //0普通会员 1白银 2黄金 3钻石
          memberLevel:
            res?.vipInfo?.type === 0
              ? "普通会员"
              : res?.vipInfo?.type === 1
              ? "白银会员"
              : res?.vipInfo?.type === 2
              ? "黄金会员"
              : res?.vipInfo?.type === 3
              ? "钻石会员"
              : "非会员" //会员等级
        };
      }
    },
    /* 获取随机日期 */
    getRandomDate() {
      const now = new Date();
      const pastDays = Math.floor(Math.random() * 90); // 90天内
      const randomDate = new Date(
        now.getTime() - pastDays * 24 * 60 * 60 * 1000
      );
      return (
        randomDate.toLocaleDateString("zh-CN") +
        " " +
        randomDate.toLocaleTimeString("zh-CN", {
          hour: "2-digit",
          minute: "2-digit"
        })
      );
    },
    /* 获取随机会员等级 */
    getRandomMemberLevel() {
      const levels = [
        "普通会员",
        "铜牌会员",
        "银牌会员",
        "金牌会员",
        "钻石会员",
        "VIP会员"
      ];
      return levels[Math.floor(Math.random() * levels.length)];
    },
    /* 弹窗关闭回调 */
    handleDialogClosed() {
      this.currentUser = {};
      this.userStats = {
        newUserCount: 0,
        repurchaseCount: 0,
        totalConsumptionCount: 0,
        totalAmount: 0,
        lastConsumptionTime: "",
        memberLevel: ""
      };
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

/* 数据统计弹窗样式 */
.user-stat-container {
  .user-info {
    background: #f5f7fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;

    h3 {
      margin: 0 0 15px 0;
      color: #303133;
      font-size: 16px;
    }

    p {
      margin: 8px 0;
      color: #606266;
      font-size: 14px;
    }
  }

  .stat-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;

    .stat-card {
      background: #ffffff;
      border: 1px solid #ebeef5;
      border-radius: 8px;
      padding: 20px;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }

      .stat-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        background: linear-gradient(135deg, #409eff, #67c23a);

        i {
          font-size: 24px;
          color: white;
        }
      }

      .stat-content {
        flex: 1;

        h4 {
          margin: 0 0 8px 0;
          color: #303133;
          font-size: 14px;
          font-weight: 600;
        }

        .stat-number {
          display: block;
          font-size: 24px;
          font-weight: bold;
          color: #409eff;
          margin-bottom: 5px;
        }

        .stat-text {
          display: block;
          font-size: 16px;
          font-weight: 600;
          color: #67c23a;
          margin-bottom: 5px;
        }

        .stat-desc {
          font-size: 12px;
          color: #909399;
          margin: 0;
        }
      }
    }
  }
}

/* 不同类型的统计卡片图标颜色 */
.stat-cards .stat-card:nth-child(1) .stat-icon {
  background: linear-gradient(135deg, #409eff, #53a8ff);
}

.stat-cards .stat-card:nth-child(2) .stat-icon {
  background: linear-gradient(135deg, #67c23a, #85ce61);
}

.stat-cards .stat-card:nth-child(3) .stat-icon {
  background: linear-gradient(135deg, #e6a23c, #ebb563);
}

.stat-cards .stat-card:nth-child(4) .stat-icon {
  background: linear-gradient(135deg, #f56c6c, #f78989);
}

.stat-cards .stat-card:nth-child(5) .stat-icon {
  background: linear-gradient(135deg, #909399, #a6a9ad);
}

.stat-cards .stat-card:nth-child(6) .stat-icon {
  background: linear-gradient(135deg, #c71585, #ff1493);
}
</style>
